import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReferences = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		transform: "translate(0 1.4118) scale(1.4118)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M11.7 12.1667L13.3 13.7222L16.5 10.6111M8.5 9.83333H5.3C3.80899 9.83333 3.06348 9.83333 2.47541 10.0702C1.69132 10.3859 1.06837 10.9916 0.743585 11.7539C0.5 12.3256 0.5 13.0504 0.5 14.5M11.3 0.726146C12.4727 1.18767 13.3 2.30546 13.3 3.61111C13.3 4.91676 12.4727 6.03455 11.3 6.49608M9.7 3.61111C9.7 5.32933 8.26731 6.72222 6.5 6.72222C4.73269 6.72222 3.3 5.32933 3.3 3.61111C3.3 1.89289 4.73269 0.5 6.5 0.5C8.26731 0.5 9.7 1.89289 9.7 3.61111Z",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	})]
});
const ForwardRef = forwardRef(SvgReferences);
export default ForwardRef;
